import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="crown, vip"><path d="M12.6278 3.33956C12.4892 3.12769 12.2532 3 12 3C11.7469 3 11.5108 3.12769 11.3723 3.33956L7.51232 9.24306L2.12793 6.10217C1.87239 5.9531 1.55311 5.96818 1.31275 6.14067C1.0724 6.31315 0.955898 6.61081 1.01531 6.90062L3.57781 19.4006C3.64933 19.7495 3.95637 20 4.31253 20H19.6875C20.0437 20 20.3507 19.7495 20.4223 19.4006L22.9848 6.90062C23.0442 6.61081 22.9277 6.31315 22.6873 6.14067C22.447 5.96818 22.1277 5.9531 21.8721 6.10217L16.4877 9.24306L12.6278 3.33956Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCrown;
